import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["name", "error", "required", "loader", "icon", "iconStyles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import { Box } from '@miro-site/core';
import inputStyles from './Input.style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled(Box).attrs({
  $styles: _objectSpread({}, inputStyles.container)
}).withConfig({
  displayName: "Input__Container",
  componentId: "sc-1ui4jav-0"
})([""]);
var Wrapper = styled(Box).attrs({
  $styles: _objectSpread({}, inputStyles.wrapper)
}).withConfig({
  displayName: "Input__Wrapper",
  componentId: "sc-1ui4jav-1"
})([""]);
var Field = styled(Box).attrs(function (_ref) {
  var theme = _ref.theme,
      isError = _ref.isError;
  return {
    as: 'input',
    $styles: _objectSpread(_objectSpread({}, inputStyles.field), {}, {
      borderColor: isError ? theme.colors.bold : theme.colors.dimmedGray
    })
  };
}).withConfig({
  displayName: "Input__Field",
  componentId: "sc-1ui4jav-2"
})([""]);
var Icon = styled(Box).attrs(function (_ref2) {
  var $styles = _ref2.$styles;
  return {
    $styles: _objectSpread(_objectSpread({}, inputStyles.icon), $styles)
  };
}).withConfig({
  displayName: "Input__Icon",
  componentId: "sc-1ui4jav-3"
})([""]);
var Error = styled(Box).attrs({
  $styles: _objectSpread({}, inputStyles.error)
}).withConfig({
  displayName: "Input__Error",
  componentId: "sc-1ui4jav-4"
})([""]);
var Input = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var name = props.name,
      error = props.error,
      required = props.required,
      loader = props.loader,
      icon = props.icon,
      iconStyles = props.iconStyles,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Wrapper, {
      children: [icon && /*#__PURE__*/_jsx(Icon, {
        $styles: iconStyles,
        "data-testid": "input-icon",
        children: icon
      }), /*#__PURE__*/_jsx(Field, _objectSpread({
        ref: ref,
        name: name,
        "aria-required": !!required,
        required: !!required,
        "aria-invalid": !!error,
        disabled: loader,
        isError: !!error
      }, rest))]
    }), error && /*#__PURE__*/_jsx(Error, {
      children: error
    })]
  });
});
Input.displayName = 'Input';
export default Input;